import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';
import {Field, FieldMap, Rule} from "../../../_typing/query-builder";
import {BaseComponent} from "../../../shared/base.component";
import {QueryBuilderFormService} from "../../../services/query-builder-form.service";
import {deepCopy} from "../../../lib/utils";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {WireFieldOptionComponent} from "./wire-field-option/wire-field-option.component";
import {WireQueryOperatorComponent} from "./wire-query-operator/wire-query-operator.component";
import {WireQueryValueComponent} from "./wire-query-value/wire-query-value.component";

@Component({
    selector: 'wire-rule',
    templateUrl: './wire-rule.component.html',
    styleUrls: ['./wire-rule.component.scss'],
    imports: [
        MatIcon,
        MatIconButton,
        WireFieldOptionComponent,
        WireQueryOperatorComponent,
        WireQueryValueComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class WireRuleComponent extends BaseComponent {
    @Input() rule: Rule;
    @Input() readonly fields: FieldMap;
    @Output() removeRuleRequest: EventEmitter<void> = new EventEmitter();
    @Output() ruleChanged: EventEmitter<void> = new EventEmitter();

    selectedField: Field;

    constructor(private queryBuilderFormService: QueryBuilderFormService) {
        super();
    }

    ngOnInit() {
        if (this.rule.field && this.fields[this.rule.field]) {
            this.selectedField = deepCopy(this.fields[this.rule.field]);
        }
    }
    
    onFieldChange(newFieldId: string) {
        this.rule.field = newFieldId;
        this.selectedField = deepCopy(this.fields[newFieldId]);
        // Reset operator and value when field changes? 
        // validation-builder didn't explicitely do it in the parent, but sub-components might handle `rule` changes.
        // Actually, FieldOptionComponent emits `selectedFieldChanged`.
        // We update `rule.field`. 
        // We should probably check if operator is still valid. 
        // For now I'll stick to simple update.
        if (this.selectedField) {
             const ops = this.queryBuilderFormService.operatorMap[this.selectedField.type];
             if (ops && !ops.includes(this.rule.operator)){
                 this.rule.operator = ops[0];
             }
        }
        this.ruleChanged.emit();
    }

    onOperatorChange(operator: string) {
        this.rule.operator = operator;
        this.ruleChanged.emit();
    }

    onValueChanged() {
        this.ruleChanged.emit();
    }

    removeRule() {
        this.removeRuleRequest.next();
    }
}
